import React from 'react';
import * as STORES from '../store/singletons';

export const storesContext = React.createContext(STORES);
(window as any).DEBUG_STORE = STORES;
(window as any).__test = {
  disconnect: () => STORES.rtStore.closeSocket(),
  reconnect: () => STORES.rtStore.getSocket(),
};
